module.exports = __webpack_public_path__ + "img/modelzh_10.cf34948a.png";